export class PreferenceAcheteurPrincipal {
  id: number;
  titre: string;
  dateCreation: Date;
  personnePhysique: boolean;
  nomOfficiel: string;
  numEnregistrement: string;
  departement: string;
  adresseInternet: string;
  urlEchangeInformation: string;
  adr1: string;
  adr2: string;
  adr3: string;
  ville: string;
  cp: string;
  entiteSecondaire: string;
  pays: string;
  pointContact: string;
  email: string;
  telephone: string;
  telecopieur: string;
}

export enum PreferenceAcheteurEnum {
  PERSONNE_PHYSIQUE = "naturalpersonindicator",
  NOM_OFFICIEL = "company_partyname[]_name",
  NUM_ENREGISTREMENT = "company_partylegalentity[]_companyid",
  DEPARTEMENT= "company_postaladdress_department",
  ADRESSE_INTERNET= "company_websiteuri",
  URL_ECHANGE_INFORMATION= "company_endpointid",
  ADR1="company_postaladdress_streetname",
  ADR2="company_postaladdress_additionalstreetname",
  ADR3="company_postaladdress_addressline[]_line",
  VILLE="company_postaladdress_cityname",
  CP="company_postaladdress_postalzone",
  ENTITE_SECONDAIRE="company_postaladdress_countrysubentitycode",
  PAYS="company_postaladdress_country_identificationcode",
  POINT_CONTACT="company_contact_name",
  EMAIL="company_contact_electronicmail",
  TELEPHONE="company_contact_telephone",
  TELECOPIEUR="company_contact_telefax"
}
